import { LineAltUnits } from './interfaces/dialog-data.interface';

// conversión de una cantidad de venta a unidad base (UMB), secundaria (UMS) y paralela (UMP);
// es informativa, sin redondear por unidad como sí hace el payload del documento.
// La UMB siempre se resuelve (la venta puede ir en una alterna que no sea ninguna de las tres);
// la UMS se muestra si el artículo la tiene y la UMP además exige el flag de la compañía
export function altUnitsOf(
  material: any,
  unitMeasureId: string | undefined,
  quantity: number,
  umpActive: boolean
): LineAltUnits {
  const aums: any[] = material?.alternalUnitOfMeasures ?? [];
  const sold = aums.find((a) => a?.unitOfMeasure?._id?.toString() === unitMeasureId);
  const qtyBase = (quantity || 0) * (Number(sold?.conversionFactor ?? sold?.equivalentQuantity ?? 1) || 1);
  const result: LineAltUnits = {};
  const label = (a: any) => a?.unitOfMeasure?.name ?? a?.unitOfMeasure?.code ?? '';

  // la cantidad base ya está en UMB; el nombre sale de la unidad marcada isUMB
  // y, si el material no la lista, del maestro del artículo
  const umb = aums.find((a) => a?.isUMB === true);
  result.umbQty = qtyBase;
  result.umbCode =
    label(umb) || material?.baseUnitOfMeasure?.name || material?.baseUnitOfMeasure?.code || '';

  const ums = aums.find((a) => a?.isSecondaryAlternativeUom === true);
  const umsFactor = Number(ums?.conversionFactor ?? ums?.equivalentQuantity ?? 0);
  if (umsFactor > 0) {
    result.umsQty = qtyBase / umsFactor;
    result.umsCode = label(ums);
  }

  const ump = aums.find((a) => a?.isUMP === true);
  const umpFactor = Number(ump?.conversionFactor ?? ump?.equivalentQuantity ?? 0);
  if (umpFactor > 0 && umpActive && material?.UMPActive === true) {
    result.umpQty = qtyBase / umpFactor;
    result.umpCode = label(ump);
  }

  return result;
}
